import { format } from "date-fns";
import moment from "moment";

function calculateDuration(from_time, to_time) {
  var from_time_f = new Date(from_time);
  var to_time_t = new Date(to_time);
  var diff = `${from_time_f.getTime()}` - `${to_time_t.getTime()}`;

  return diff;
}

const customerDetailParser = {};

customerDetailParser.getpersonalDetail = (res) => {

  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }

  const parsePhotos = (t) =>
    t.map((e) => {
      return {
        image: e?.thumbnail,
        chargingStation_id: e?.station_id,
        StationName: e?.station !== null ? e.station.name : " ",
        date: format(new Date(e?.created_at), "dd MMM yyyy"),
      };
    });

  let VehicleName = "";

  for (let i = 0; i < res?.my_vehicles.length; i++) {
    if (i < 3) {
      VehicleName =
        VehicleName +
        res?.my_vehicles[i].manufacturer?.name +
        " " +
        res?.my_vehicles[i].vehicle_model?.name +
        ",";
    }
    if (i === 3) {
      VehicleName =
        VehicleName +
        res?.my_vehicles[i].manufacturer?.name +
        " " +
        res?.my_vehicles[i].vehicle_model?.name;
      break;
    }
  }

  let data = {
    name: res?.first_name + " " + res?.last_name,
    profilePic: res?.thumbnail,
    mobile: res?.mobile,
    carName: VehicleName,
    email: res?.email,
    photos: parsePhotos(res?.customer_attachment),
    bookingCount: res?.customerBookings.length,
  };

  return data;
};

customerDetailParser.getChargingData = (res) => {
  if (res) {
    res = res !== null ? res.result.customerBookings : " ";
  }

  if (!res) {
    return [];
  }

  // date
  const bookingDate = (date) => {
    const day = format(new Date(date), "EEEE");
    return `${day} ${date}`;
  };

  //invoice
  const parseAmenities = (t) =>
    t?.map((e) => ({
      thumbnail: e.amenity?.thumbnail,
      name: e.amenity?.name,
    }));

  const parseCharging = (t) =>
    t?.map((e) => {
      const calculateTotalAmount = (invoice) => {
        let gstData = invoice?.map((element, j) => ({
          advance_amt: invoice[0]?.total_amount,
          gross_amt: invoice[1]?.gross_amount,
          convenience_amount: invoice[1]?.convenience_amount,
          tax_amount: invoice[1]?.tax_amount,
          total_amount: invoice[0]?.net_amount + invoice[1]?.net_amount,
        }));
        return gstData;
      };

      const calculateTimeDuratinPercentage = (invoice) => {
        if (
          e.charging_status === "CANCELLED" ||
          e.charging_status === "BOOKED" ||
          e.charging_status === "ADVANCE_PENDING"
        ) {
          return 0;
        } else if (
          e.charging_status === "IN_PROGRESS" ||
          e.charging_status === "COMPLETED" ||
          e.charging_status === "BALANCE_PENDING"
        ) {
          var timeDuration = moment
            .utc(
              moment(e.actual_stop_time, "HH:mm:ss").diff(
                moment(e.actual_start_time, "HH:mm:ss")
              )
            )
            .format("mm:ss");

          return timeDuration;
        }
      };

      const calculateSpinnerPercentage = (invoice) => {
        if (
          e.charging_status === "CANCELLED" ||
          e.charging_status === "BOOKED"
        ) {
          return 0;
        } else if (e.charging_status === "IN_PROGRESS") {
          const currentTime = moment(new Date()).format("HH:mm:ss");
          const TimeDuration = moment
            .utc(currentTime, "HH:mm:ss")
            .diff(moment.utc(e.from_time, "HH:mm:ss"));

          const slotTime = moment
            .utc(e.to_time, "HH:mm:ss")
            .diff(moment.utc(e.from_time, "HH:mm:ss"));

          var percentageTime = (TimeDuration / slotTime) * 100;

          return percentageTime;
        } else if (
          e.charging_status === "BALANCE_PENDING" ||
          e.charging_status === "COMPLETED" ||
          e.charging_status === "ADVANCE_PENDING"
        ) {
          const TimeDurationComplete = moment
            .utc(
              moment(e.actual_stop_time, "HH:mm:ss").diff(
                moment(e.actual_start_time, "HH:mm:ss")
              )
            )
            .format("mm");

          const slotTimeComplete = moment
            .utc(
              moment(e.to_time, "HH:mm:ss").diff(
                moment(e.from_time, "HH:mm:ss")
              )
            )
            .format("mm");

          var percentageComplete =
            (TimeDurationComplete / slotTimeComplete) * 100;

          return percentageComplete;
        }
      };
      const calculateGst = (invoice) => {
        let gstData = invoice?.map((gst, i) => ({
          cgst: gst?.cgst,
          igst: gst?.igst,
          sgst: gst?.sgst,
          gross_amt: 0,
          tax_amount: 0,
          advance_amt: gst?.net_amount,
          total_amount: gst?.total_amount,
          convenience_amount: 0,
        }));
        return gstData;
      };

      return {
        carName:
          e?.vehicleBookings !== null
            ? e?.vehicleBookings.manufacturer?.name +
              " " +
              e?.vehicleBookings.vehicle_model?.name
            : " ",
        img:
          e.vehicleBookings !== null
            ? e.vehicleBookings.manufacturer?.thumbnail
            : "",
        sub: "Variant",
        chademo:
          e.connectorBookings == null
            ? ""
            : e.connectorBookings?.charger_type?.name,
        chademoImage:
          e.connectorBookings == null
            ? ""
            : e.connectorBookings?.charger_type.thumbnail,
        power:
          e.connectorBookings == null
            ? " "
            : e.connectorBookings?.price_per_khw,
        time: calculateDuration(
          e.to_time ? e.to_time : "",
          e.from_time ? e.from_time : ""
        ),
        amount:
          e.charging_status === "COMPLETED"
            ? "₹" + e.payable_amount ?? ""
            : e.invoice[0]?.total_amount,
        StationName: e.chargingStation == null ? "" : e.chargingStation?.name,

        charging_status:
          e.charging_status !== null ? e.charging_status : "Charging",
        date: e !== null ? bookingDate(e.date) : "date not found",
        
        SecondTime: calculateTimeDuratinPercentage(e.invoice)
          ? calculateTimeDuratinPercentage(e.invoice)
          : "00:00",

        invoice: {
          carName:
            e?.vehicleBookings == null
              ? ""
              : e?.vehicleBookings?.manufacturer?.name +
                " " +
                e?.vehicleBookings?.vehicle_model?.name,

          img:
            e.vehicleBookings !== null
              ? e.vehicleBookings.manufacturer?.thumbnail
              : "",
          chademo:
            e.connectorBookings == null
              ? ""
              : e.connectorBookings?.charger_type.name,

          chademoImage:
            e.connectorBookings == null
              ? ""
              : e.connectorBookings?.charger_type.thumbnail,
          networkName:
            e.chargingStation !== null
              ? e.chargingStation.chargingNetwork.name
              : "Reliance Power",

          power:
            e.connectorBookings == null
              ? " "
              : e.connectorBookings?.price_per_khw,
          date: e !== null ? bookingDate(e.date) : "date not found",
          time:
            e !== null
              ? `${moment("2023-01-01 " + e.from_time).format(
                  "hh:mm A"
                )} to ${moment("2023-01-01 " + e.to_time).format("hh:mm A")}`
              : "time not found",
          SecondTime: calculateTimeDuratinPercentage(e.invoice)
            ? calculateTimeDuratinPercentage(e.invoice)
            : "0",

          progress: calculateSpinnerPercentage(e.invoice)
            ? calculateSpinnerPercentage(e.invoice)
            : "0",
          chargingFee: 45.0,
          amenities: parseAmenities(
            e.chargingStation ? e.chargingStation?.stationsAmenities : ""
          ),
          gst:
            e.charging_status === "COMPLETED"
              ? calculateTotalAmount(e.invoice)
              : calculateGst(e.invoice),
        },
      };
    });

  const data = parseCharging(res);
  return data;
};

customerDetailParser.getReviews = (res) => {
  if (res) {
    res = res.result;
  }

  if (!res) {
    return [];
  }

  const Name = res.customer.first_name
    ? res.customer.first_name
    : " " + res.customer.last_name
    ? res.customer.last_name
    : "";
  const profilePic = res.customer.thumbnail ? res.customer.thumbnail : " ";

  const parseDetail = (t) =>
    t.map((e) => {
      return {
        location: e.station_name ? e.station_name : "",
        feedback: e.review ? e.review : "",
        dp: profilePic,
        name: Name ? Name : "",
        rating: e ? e.rating : "",
        date: format(new Date(e.created_at), "dd MMM yyyy"),
      };
    });

  const data = parseDetail(res.feedback);

  return data;
};
export { customerDetailParser };
